<template>
  <div class="d-flex flex-grow-1 h-0 flex-column">
    <GmbDisplayHeading
        :text="activatedEntity ? activatedEntity.entityObj.label : ''"
        :enableDescriptionDisplay="enableDescriptionDisplay"
    >
      <!-- GmbSidePanelBlocDisplayHeadingPictoTooltip /-->
    </GmbDisplayHeading>

    <GmbRow>
      <template #picto>
        <slot name="picto"/>
      </template>

      <FdText class="gmb-level-bar__label" oneline tag="span"
      >Effectif théorique
      </FdText
      >

      <template #infoSticker>
        <GmbIndividualSticker
            :individualCount="theoreticalIndividualWorkforce"
        />
      </template>
    </GmbRow>

    <GmbRow>
      <template #picto>
        <slot name="picto"/>
      </template>

      <FdText class="gmb-level-bar__label" oneline tag="span"
      >Effectif importé
      </FdText
      >

      <template #infoSticker>
        <GmbIndividualSticker :individualCount="importedIndividualWorkforce"/>
      </template>
    </GmbRow>

    <div class="d-flex mt-1 border-top border-light"/>
    <div class="d-flex flex-grow-1 h-0 flex-column">
      <FdScroll y>
        <div class="d-flex mt-3"/>
        <GmbSidePanelSourcedOrganizations
            :organizations="organizations"
            @organization-data-sources-activated-address-changed="
            (organizationSlug, newActivatedAddressSlug) =>
              $emit(
                'organization-data-sources-activated-address-changed',
                organizationSlug,
                newActivatedAddressSlug
              )
          "
            @organization-data-sources-activated-organizations-changed="
            (newActivatedOrganizationSlugs) =>
              $emit(
                'organization-data-sources-activated-organizations-changed',
                newActivatedOrganizationSlugs
              )
          "
        />

        <div class="d-flex mt-3 border-top pt-3"/>
        <GmbSidePanelFilters
            v-if="
            organizationFilterCategory &&
            organizationFilterCategory.filters.length
          "
            categoryFAPictoCssClasses="fas fa-tag"
            collapseIsVisibleByDefault
            :filterCategory="organizationFilterCategory"
            title="Profil des sites"
            ref="organizationFilterCategoryRef"
            @filter-activated-options-changed="
            (filterSlug, newActivatedFilterOptionSlugs) =>
              $emit(
                'organization-filter-activated-options-changed',
                filterSlug,
                newActivatedFilterOptionSlugs
              )
          "
        />

        <div
            v-if="
            organizationFilterCategory &&
            organizationFilterCategory.filters.length
          "
            class="d-flex mt-3"
        />

        <GmbSidePanelFilters
            v-if="
            individualFilterCategory && individualFilterCategory.filters.length
          "
            categoryFAPictoCssClasses="fas fa-tag"
            collapseIsVisibleByDefault
            :filterCategory="individualFilterCategory"
            ref="individualFilterCategoryRef"
            title="Profil des individus"
            @filter-activated-options-changed="
            (filterSlug, newActivatedFilterOptionSlugs) =>
              $emit(
                'individual-filter-activated-options-changed',
                filterSlug,
                newActivatedFilterOptionSlugs
              )
          "
        />

        <div class="d-flex mt-3"/>

        <GmbSidePanelFilters
            v-if="
            transportFilterCategory && transportFilterCategory.filters.length
          "
            categoryFAPictoCssClasses="fas fa-person-biking"
            collapseIsVisibleByDefault
            :filterCategory="transportFilterCategory"
            picto="fa-biking"
            title="Accessibilité"
            @filter-activated-options-changed="
            (filterSlug, newActivatedFilterOptionSlugs) =>
              $emit(
                'transport-filter-activated-options-changed',
                filterSlug,
                newActivatedFilterOptionSlugs
              )
          "
        />

        <div class="d-flex mt-3"/>

        <GmbSidePanelFilters
            v-if="
            comparisonFilterCategory && comparisonFilterCategory.filters.length
          "
            categoryFAPictoCssClasses="fas fa-scale-balanced"
            collapseIsVisibleByDefault
            :filterCategory="comparisonFilterCategory"
            picto="fa-stopwatch"
            title="Comparaisons"
            @filter-activated-options-changed="
            (filterSlug, newActivatedFilterOptionSlugs) =>
              $emit(
                'comparison-filter-activated-options-changed',
                filterSlug,
                newActivatedFilterOptionSlugs
              )
          "
        />
        <div class="d-flex pt-4"/>
      </FdScroll>
    </div>
    <div class="d-flex border-top border-light pt-1"/>

    <GmbRow>
      <template #picto>
        <slot name="picto"/>
      </template>

      <FdText class="gmb-level-bar__label" oneline tag="span"
      >Effectif des sites sélectionnés
      </FdText
      >

      <template #infoSticker>
        <GmbIndividualSticker :individualCount="sourcedIndividualWorkforce"/>
      </template>
    </GmbRow>

    <GmbRow>
      <template #picto>
        <slot name="picto"/>
      </template>

      <FdText class="gmb-level-bar__label" oneline tag="span"
      >Effectif cible
      </FdText
      >

      <template #infoSticker>
        <GmbIndividualSticker
            :individualCount="finalFilteredIndividualWorkforce"
        />
      </template>
    </GmbRow>

    <div class="d-flex pt-1"/>

    <GmbCopyrightRow/>
  </div>
</template>

<script>
import FdScroll from "@/flexdesign/Scroll";
import FdText from "@/flexdesign/Text";

import GmbCopyrightRow from "@/widgets/CopyrightRow";
import GmbDisplayHeading from "@/widgets/DisplayHeading";
import GmbIndividualSticker from "@/widgets/IndividualSticker";
import GmbRow from "@/widgets/Row";

//import GmbSidePanelDisplayHeadingPictoTooltip from "@/views/Observatory/SidePanel/SidePanelDisplayHeadingPictoTooltip";
import GmbSidePanelFilters from "@/views/Observatory/SidePanel/SidePanelFilters";
import GmbSidePanelSourcedOrganizations from "@/views/Observatory/SidePanel/SidePanelSourcedOrganizations";

export default {
  name: "GmbSidePanel",

  components: {
    FdScroll,
    FdText,

    GmbCopyrightRow,
    GmbDisplayHeading,
    GmbIndividualSticker,
    GmbRow,

    //GmbSidePanelBlocDisplayHeadingPictoTooltip,
    GmbSidePanelFilters,
    GmbSidePanelSourcedOrganizations,
  },

  props: {
    activatedEntity: Object,
    comparisonFilterCategory: Object,
    finalFilteredIndividualWorkforce: Number,
    importedIndividualWorkforce: Number,
    individualFilterCategory: Object,
    organizationFilterCategory: Object,
    organizations: Array,
    sourcedIndividualWorkforce: Number,
    theoreticalIndividualWorkforce: Number,
    transportFilterCategory: Object,
    enableDescriptionDisplay: Boolean,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss"></style>
